import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPartnersImages } from "../../redux/slicer/homeSlicer";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

function Carousel2() {
  const dispatch = useDispatch();
  const { images, loading, error } = useSelector(
    (state) => state.home.partners
  );

  useEffect(() => {
    dispatch(fetchPartnersImages());
  }, [dispatch]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Calculate slidesToShow based on the number of images
  const slidesToShow = Math.min(images.length, 5); // Show at most 5 slides

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    prevArrow: (
      <div className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
        <FaChevronLeft className="text-primary-color text-lg" />
      </div>
    ),
    nextArrow: (
      <div className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
        <FaChevronRight className="text-primary-color text-lg" />
      </div>
    ),
    responsive: [
      {
        breakpoint: 1536,
        settings: { slidesToShow: Math.min(images.length, 4) },
      },
      {
        breakpoint: 1280,
        settings: { slidesToShow: Math.min(images.length, 3) },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: Math.min(images.length, 3) },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 2 },
      },
    ],
  };
  

  return (
    <div className="relative w-full max-w-5xl mx-auto">
      {images.length > 0 && (
        <Slider {...settings}>
          {images.map((image, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center bg-white"
            >
              {/* Image with onClick handler */}
              <img
  src={image.image_url}
  className="w-[176px] h-[53px] sm:h-[200px] object-scale-down cursor-pointer mx-auto"
  alt={`Slide ${index + 1}`}
  onClick={() => window.open(image.url, "_blank")}
/>

              <h2 className="text-xl font-bold text-primary-color mt-4">
                {image.partner_name}
              </h2>
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
}

export default Carousel2;
